import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Redirect, useHistory } from "react-router-dom";

import { isEmpty, isLoaded } from "react-redux-firebase";

import { ListItem, ListItemIcon } from "@material-ui/core";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";

import firebase from "../../../services/firebase";
import ConfirmDialog from "../../../components/ConfirmDialog";

export default () => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [errorDialogOpen, setErrorDialogOpen] = useState(false);
  const [error, setError] = useState(null);
  const history = useHistory();

  const handleDelete = async () => {
    setDialogOpen(false);
    try {
      await firebase.auth().currentUser.delete();
      history.push("/account-deleted");
    } catch (error) {
      console.log("error:", error);
      setErrorDialogOpen(true);
      setError(error);
    }
  };

  return (
    <>
      <ListItem button onClick={() => setDialogOpen(true)}>
        <ListItemIcon>
          <DeleteForeverIcon />
        </ListItemIcon>
        Delete Account
      </ListItem>
      <ConfirmDialog
        title="Delete Account Forever"
        open={dialogOpen}
        onCancel={() => setDialogOpen(false)}
        onConfirm={handleDelete}
      >
        Are you sure you'd like to delete your account and all data? This is
        irreverisble and to use Reconcile in the future you'll have to start
        over by creating a new account.
      </ConfirmDialog>
      <ConfirmDialog
        title="Deletion Error"
        open={errorDialogOpen}
        onCancel={() => setErrorDialogOpen(false)}
        onConfirm={() => firebase.auth().signOut()}
      >
        {error && error.message}
      </ConfirmDialog>
    </>
  );
};
